import { render, staticRenderFns } from "./pagingfy.vue?vue&type=template&id=e0b4c130&"
import script from "./pagingfy.vue?vue&type=script&lang=js&"
export * from "./pagingfy.vue?vue&type=script&lang=js&"
import style0 from "./pagingfy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports